/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMap } from '../../factoriesAny.js';
export var mapDependencies = {
  typedDependencies,
  createMap
};